import React from 'react';
import {
  DocumentTypesInfiniteSelectField,
  FloatingFormItem,
} from '@/components/_common';
import { ConfirmPurchaseFormValues } from '@/core/domain/purchase/purchaseImport/PurchaseImport.types';
import { useDefaultEmptyFieldError } from '@/hooks';
import { Col, Form, Row } from 'antd';
import { FormInstance } from 'antd/es/form/Form';

interface Props {
  form: FormInstance<ConfirmPurchaseFormValues>;
}

const ConfirmImportForm: React.FC<Props> = ({ form }) => {
  const defaultEmptyFieldError = useDefaultEmptyFieldError();

  return (
    <Form form={form}>
      <Row gutter={[16, 8]}>
        <Col span={24} md={12} lg={8} xxl={6}>
          <FloatingFormItem
            label="Tipo de documento"
            name="documentTypeId"
            rules={[defaultEmptyFieldError]}
          >
            <DocumentTypesInfiniteSelectField />
          </FloatingFormItem>
        </Col>
      </Row>
    </Form>
  );
};

export default ConfirmImportForm;
